import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  InputNumber,
  DatePicker,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const TosPaymentTableFilter = (props) => {
  const [form] = Form.useForm();
  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });
  useEffect(() => {
    getBanks();
    getPaymentTypes();
    if (props.currencyOptions && props.currencyOptions.length > 0) {
      setCurrencySelect({
        data: props.currencyOptions,
        loading: false,
      });
    } else {
      getCurrencies();
    }
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data, props.currencyOptions, props.showSwiftFilters]);

  const [userSelect, setUserSelect] = useState({
    data: [],
    loading: false,
  });

  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });

  const [paymentTypeSelect, setPaymentTypeSelect] = useState({
    data: [],
    loading: false,
  });

  const getBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });

    RequestHandler.get(`/bank/GetPaymentDropdown`).then(
      (response) => {
        setBankSelect({
          data: response,
          loading: false,
        });
      }
    );
  };

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });
    RequestHandler.get(`/Payment/CurrencyList`).then((response) => {
      const data = response?.data || response?.value || response || [];
      setCurrencySelect({
        data,
        loading: false,
      });
    });
  };

  const getPaymentTypes = () => {
    setPaymentTypeSelect({ ...paymentTypeSelect, loading: true });
    const isSwift = props.showSwiftFilters === true;
    RequestHandler.get(`/Payment/PaymentTypes?isSwiftTransfer=${isSwift}`).then((response) => {
      setPaymentTypeSelect({
        data: Array.isArray(response) ? response : [],
        loading: false,
      });
    }).catch(() => setPaymentTypeSelect({ data: [], loading: false }));
  };
  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];
      conditions.push(`&$filter=statusId eq 1`)

      if (!props.showSwiftFilters && values.bankId) {
        conditions.push(`bankId eq ${values.bankId}`);
      }
      if (values.title) {
        conditions.push(`Contains(title,'${values.title}')`);
      }
      if (!props.showSwiftFilters && values.bankBranchId) {
        conditions.push(`bankBranchId eq ${values.bankBranchId}`);
      }
      if (!props.showSwiftFilters && values.accountNumber) {
        conditions.push(`Contains(accountNumber,'${values.accountNumber}')`);
      }
      if (values.addUserId) {
        if (values.addUserId.startsWith("_"))
          conditions.push(`${odata.contains("addUserName", values.addUserId.slice(1))}`);
        else
          conditions.push(`addUserId eq ${values.addUserId}`);
      }
      if (values.updateUserId) {
        if (values.updateUserId.startsWith("_"))
          conditions.push(`${odata.contains("updateUserName", values.updateUserId.slice(1))}`);
        else
          conditions.push(`updateUserId eq ${values.updateUserId}`);
      }
      if (values.iban) {
        conditions.push(`Contains(iban,'${values.iban}')`);
      }
      if (values.description) {
        conditions.push(odata.contains("description", values.description));
      }
      if (values.currencyId) {
        conditions.push(`currencyId eq ${values.currencyId}`);
      }
      if (values.paymentTypeId) {
        conditions.push(`paymentTypeId eq ${values.paymentTypeId}`);
      }

      const amountQuery = odata.ConditionalRange(
        "amount",
        values.amountMin,
        values.amountMax
      );
      if (amountQuery) conditions.push(amountQuery);
      if (values.paymentDateRange) {
        const [startDate, endDate] = values.paymentDateRange;
        conditions.push(odata.dateRange("paymentDate", startDate, endDate));
      }
      if (props.showSwiftFilters) {
        if (values.swiftCode) {
          conditions.push(`Contains(swiftCode,'${values.swiftCode}')`);
        }
        if (values.swiftBankName) {
          conditions.push(`Contains(swiftBankName,'${values.swiftBankName}')`);
        }
        if (values.invoiceNumber) {
          conditions.push(`Contains(invoiceNumber,'${values.invoiceNumber}')`);
        }
        if (values.swiftChargeType) {
          conditions.push(`swiftChargeTypeId eq ${values.swiftChargeType}`);
        }
      }
      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  const onUserSearch = (value) => {
    if (value.length >= 2) {
      setUserSelect({ data: [], loading: true });
      RequestHandler.get(
        `/TenantUser?$select=id,userId,firstName,lastName&$filter=isActive eq true and isDeleted eq false and (${odata.contains("firstName", value)} or ${odata.contains("lastName", value)})`
      ).then((res) => {
        const mapped = (res.value || []).map((u) => ({
          id: u.userId,
          compoundNoun: [u.firstName, u.lastName].filter(Boolean).join(" "),
        }));
        setUserSelect({ data: [{ id: `_${value}`, compoundNoun: `'${value}' içerenleri ara` }].concat(mapped), loading: false });
      });
    } else {
      setUserSelect({ data: [], loading: false });
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                {!props.showSwiftFilters && (
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="bankId" label="Banka :">
                      <Select
                        allowClear
                        showSearch
                        placeholder="Tümü"
                        loading={bankSelect.loading}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                        }
                      >
                        {bankSelect.data.map((item) => (
                          <Select.Option key={item.id} value={item.id}>
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                )}

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="title" label="Ad Soyad / Ünvan :">
                    <Input placeholder="Ad Soyad / Ünvan" />
                  </Form.Item>
                </Col>

                {!props.showSwiftFilters && (
                  <>
                    <Col xs={24} md={12} lg={6}>
                      <Form.Item name="bankBranchId" label="Şube Kodu :">
                        <Input placeholder="Şube Kodu" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={6}>
                      <Form.Item name="accountNumber" label="Hesap Numarası :">
                        <Input placeholder="Hesap Numarası" />
                      </Form.Item>
                    </Col>
                  </>
                )}

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="iban" label="Iban :">
                    <Input placeholder="Iban" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item style={{ marginBottom: 0 }} label="Tutar :">
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMin">
                            <InputNumber style={{ width: "100%" }} placeholder="Min" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMax">
                            <InputNumber style={{ width: "100%" }} placeholder="Max" />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="currencyId" label="Döviz :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={currencySelect.loading}
                    >
                      {currencySelect.data.map(({ id, code }) => (
                        <Select.Option key={id} value={id}>
                          {code}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="paymentTypeId" label="İşlem Tipi :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      loading={paymentTypeSelect.loading}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {paymentTypeSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="description" label="Açıklama :">
                    <Input placeholder="Açıklama" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="paymentDateRange" label="Ödeme Tarihi :">
                    <DatePicker.RangePicker style={{ width: "100%" }} format="DD.MM.YYYY" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="addUserId" label={`Talimatı Ekleyen :`} >
                    <Select
                      allowClear
                      showSearch
                      style={{ width: "100%" }}
                      dropdownStyle={{ minWidth: "50%" }}
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onUserSearch}
                      filterOption={(input, option) => {
                        const inputLower = input.toLocaleLowerCase("tr-TR");
                        const children = option.children ? option.children.toLocaleLowerCase("tr-TR") : '';
                        const code = option.code ? option.code.toLocaleLowerCase("tr-TR") : '';
                        return children.indexOf(inputLower) >= 0 || code.indexOf(inputLower) >= 0;
                      }}
                      loading={userSelect.loading}
                    >
                      {userSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.compoundNoun}
                        >
                          {item.compoundNoun}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="updateUserId" label={`Son Güncelleyen :`} >
                    <Select
                      allowClear
                      showSearch
                      style={{ width: "100%" }}
                      dropdownStyle={{ minWidth: "50%" }}
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onUserSearch}
                      filterOption={(input, option) => {
                        const inputLower = input.toLocaleLowerCase("tr-TR");
                        const children = option.children ? option.children.toLocaleLowerCase("tr-TR") : '';
                        const code = option.code ? option.code.toLocaleLowerCase("tr-TR") : '';
                        return children.indexOf(inputLower) >= 0 || code.indexOf(inputLower) >= 0;
                      }}
                      loading={userSelect.loading}
                    >
                      {userSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.compoundNoun}
                        >
                          {item.compoundNoun}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                {props.showSwiftFilters && (
                  <>
                    <Col xs={24} md={12} lg={6}>
                      <Form.Item name="swiftCode" label="Swift Kod :">
                        <Input placeholder="Swift Kod" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                      <Form.Item name="swiftBankName" label="Swift Banka Ünvan :">
                        <Input placeholder="Swift Banka Ünvan" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                      <Form.Item name="invoiceNumber" label="Fatura No :">
                        <Input placeholder="Fatura No" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} lg={6}>
                      <Form.Item name="swiftChargeType" label="Masraf :">
                        <Select allowClear placeholder="Tümü">
                          <Select.Option value={1}>BEN</Select.Option>
                          <Select.Option value={2}>SHA</Select.Option>
                          <Select.Option value={3}>OUR</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </>
                )}

              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default TosPaymentTableFilter;
